<template>
    <div :style="{height : height + 'px'}" style="overflow-y: auto;">
        <v-data-table :dense="items.length > 13" :headers="headers" :items="items" :items-per-page="itemsPerPage"
            class="elevation-0 pnectable" :hide-default-footer="items.length < itemsPerPage" sort-by="substance"
            :mobile-breakpoint="0">
            <template v-slot:item.pnec="{ item }">
                <span v-if="countDecimals(item.pnec) >= 7" style="white-space: nowrap;">{{item.pnec/1000000}}
                    mg/L</span>
                <span v-else-if="countDecimals(item.pnec) >= 4" style="white-space: nowrap;">{{item.pnec/1000}}
                    µg/L</span>
                <span v-else style="white-space: nowrap;">{{item.pnec}} ng/L</span>
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import { PNEC } from '../../ts/pnec.ts'

    export default {
        props: {
            pnec: {
                required: false,
                type: PNEC
            },
            height: {
                type: Number,
                default: 300
            },
            itemsPerPage: {
                type: Number,
                default: 999 // while -1 makes more sense, 999 allows us to calculate when to hide footer more easily.
            }
        },
        data() {
            return {
                headers: [
                    { text: 'Substance', value: 'substance' },
                    { text: 'PNEC', value: 'pnec' },
                ],
            }
        },
        computed: {
            items() {
                const arr = []
                for (const substance of Object.keys(this.pnec.bySubstance)) {
                    arr.push({
                        substance: substance,
                        pnec: this.pnec.bySubstance[substance]
                    })
                }
                // Sort alphabetically (case insensitive)
                arr.sort((a,b) => (a.substance.toLowerCase() > b.substance.toLowerCase()) ? 1 : ((b.substance.toLowerCase() > a.substance.toLowerCase()) ? -1 : 0))
                return arr
            }
        },
        methods: {
            countDecimals(number) {
                return Math.floor(Math.log10(number) + 1);
            }
        }
    }
</script>

<style>
    .pnectable .v-data-footer__select {
        display: none;
    }

    .pnectable td {
        font-size: 13px !important;
    }

    .pnectable th {
        font-size: 13px !important;
        white-space: nowrap;
        min-width: 85px;
    }
</style>